import React, { Component } from 'react';
import { Button, Icon } from 'react-materialize';
import '../css/docs.css';

class Documentation extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return(
      <div>
        <div className="docs">
          <div>
            <div className="docs-item docs-item__image docs-item__image-1"></div>
            <div className="docs-item docs-item__text">
              <h5>Общий каталог производимой продукции</h5>
              <a href="../documentation/catalog_all.pdf" target="_blank">
                <Button waves='light' className="btn-view">Просмотр<Icon left>visibility</Icon></Button>
              </a>
              <a href="../documentation/catalog_all.pdf" className="btn-download" download>
                <Button waves='light'>Скачать<Icon left>get_app</Icon></Button>
              </a>
            </div>
          </div>
          <div>
            <div className="docs-item docs-item__image docs-item__image-2"></div>
            <div className="docs-item docs-item__text">
              <h5>Каталог производимых металлических опор</h5>
              <a href="../documentation/catalog_mgk.pdf" target="_blank">
                <Button waves='light' className="btn-view">Просмотр<Icon left>visibility</Icon></Button>
              </a>
              <a href="../documentation/catalog_mgk.pdf" download>
                <Button waves='light' className="btn-download">Скачать<Icon left>get_app</Icon></Button>
              </a>
            </div>
          </div>
          <div>
            <div className="docs-item docs-item__text">
              <h5>Каталог продукции для железнодорожной инфраструктуры</h5>
              <a href="../documentation/catalog_rgd.pdf" target="_blank">
                <Button waves='light' className="btn-view">Просмотр<Icon left>visibility</Icon></Button>
              </a>
              <a href="../documentation/catalog_rgd.pdf" download>
                <Button waves='light' className="btn-download">Скачать<Icon left>get_app</Icon></Button>
              </a>
            </div>
            <div className="docs-item docs-item__image docs-item__image-3"></div>
          </div>
          <div>
            <div className="docs-item docs-item__text">
              <h5>Каталог по сборным гофрированным конструкциям</h5>
              <a href="../documentation/katalog_gofra_r.pdf" target="_blank">
                <Button waves='light' className="btn-view">Просмотр<Icon left>visibility</Icon></Button>
              </a>
              <a href="../documentation/katalog_gofra_r.pdf" download>
                <Button waves='light' className="btn-download">Скачать<Icon left>get_app</Icon></Button>
              </a>
            </div>
            <div className="docs-item docs-item__image docs-item__image-4"></div>
          </div>
          <div>
            <div className="docs-item docs-item__image docs-item__image-5"></div>
            <div className="docs-item docs-item__text">
              <h5>Каталог продукции Спиральновитые Гофрированные Металлические трубы</h5>
              <a href="../documentation/katalog_opory.pdf" target="_blank">
                <Button waves='light' className="btn-view">Просмотр<Icon left>visibility</Icon></Button>
              </a>
              <a href="../documentation/katalog_opory.pdf" download>
                <Button waves='light' className="btn-download">Скачать<Icon left>get_app</Icon></Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Documentation;



// WEBPACK FOOTER //
// ./src/components/documentation.js